export default {
  isDesktop () {
    const userAgent = window.navigator.userAgent
    const isAndroid = /android/i.test(userAgent)
    let isiOS = !!userAgent.match(/iPad/i) || !!userAgent.match(/iPhone/i)
    if (!isiOS) { isiOS = !!userAgent.match(/Mac/i) && !!navigator.maxTouchPoints } // Check for iPad Pro 13'+
    return (!isiOS && !isAndroid)
  },

  deserializeBoolean (value) {
    return (value === 1 || value === '1' || value === 'true')
  },

  deserializeFloat (value) {
    return parseFloat(value)
  },

  buildBackgroundShade (hexa) {
    return JSON.stringify({ shadeTop: hexa, shadeBottom: hexa })
  },

  buildWatermarkPosition (position) {
    let builded

    switch (position) {
      case 'top-left': builded = { x: 0, y: 0 }; break
      case 'top-mid': builded = { x: 0.5, y: 0 }; break
      case 'top-right': builded = { x: 1, y: 0 }; break
      case 'mid-left': builded = { x: 0, y: 0.5 }; break
      case 'mid-right': builded = { x: 1, y: 0.5 }; break
      case 'bot-left': builded = { x: 0, y: 1 }; break
      case 'bot-mid': builded = { x: 0.5, y: 1 }; break
      case 'bot-right': builded = { x: 1, y: 1 }; break
      default: builded = { x: 0.5, y: 1 }; break
    }

    return JSON.stringify(builded)
  },
}
